export default __webpack_public_path__ + "static/132-0a86a08207abc7170c482de79d2ff672.gif";